export default __webpack_public_path__ + "static/media/lab3.e06dbd76.jpg";